export default "__VITE_ASSET__llEh9fWk__"